// extracted by mini-css-extract-plugin
export default {"FixedButtonContainer":"Insurance_FixedButtonContainer__qZAVa"};